import type { ReactNode } from 'react';

export const symbol_trophy: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M450-180v-148q-54-11-96-46.5T296-463q-74-8-125-60t-51-125v-44q0-24.75 17.63-42.38Q155.25-752 180-752h104v-28q0-24.75 17.63-42.38Q319.25-840 344-840h272q24.75 0 42.38 17.62Q676-804.75 676-780v28h104q24.75 0 42.38 17.62Q840-716.75 840-692v44q0 73-51 125t-125 60q-16 53-58 88.5T510-328v148h122q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H328q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h122ZM284-526v-166H180v44q0 45 29.5 78.5T284-526Zm292.5 101.04Q616-464.92 616-522v-258H344v258q0 57.08 39.74 97.04Q423.47-385 480.24-385q56.76 0 96.26-39.96ZM676-526q45-10 74.5-43.5T780-648v-44H676v166Zm-196-57Z"
		/>
	</svg>
);
